import { render, staticRenderFns } from "./EmployeePostTransfer.vue?vue&type=template&id=d8120224&scoped=true&"
import script from "./EmployeePostTransfer.vue?vue&type=script&lang=js&"
export * from "./EmployeePostTransfer.vue?vue&type=script&lang=js&"
import style0 from "./EmployeePostTransfer.vue?vue&type=style&index=0&id=d8120224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8120224",
  null
  
)

export default component.exports